export const Historic1CareOptions = [
  {
    label:'Facility',
    type:'text',
    recordName: 'facility'
  },
  {
    label:'Day In',
    type:'text',
    recordName: 'admission_date'
  },
  {
    label:'Day Out',
    type:'text',
    recordName: 'discharge_date'
  },
  {
    label:'Days',
    type:'calculation',
    recordName: 'calculation'
  },
]